/**
 * Appends patientGuid as a query parameter to a URL for portal API requests.
 * Used so backend receives patient context (selected patient when guardian, own guid when direct patient).
 */
export function withPatientParam(url: string, patientGuid: string | null): string {
  if (!patientGuid) return url;
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}patientGuid=${encodeURIComponent(patientGuid)}`;
}
